import script from "./add.vue?vue&type=script&setup=true&lang=js"
export * from "./add.vue?vue&type=script&setup=true&lang=js"

import "./add.vue?vue&type=style&index=0&id=c1b78a90&lang=less&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1b78a90"]])

export default __exports__